import IAnswer from '../../models/IAnswer';
import IAssessment from '../../models/IAssessment';
import IAssessmentPage from '../../models/IAssessmentPage';

import { Actions } from './actions';

export interface IAssessmentState 
{
	assessment: IAssessment | null,
	page: IAssessmentPage | null,
	pageAnswers: IAnswer[],
	pageActionsComplete: boolean,
	pageIndex: number,
	totalPages: number,
	isFirstPage: boolean,
	isLastPage: boolean,
}

export const initialState: IAssessmentState =
{
	assessment: null,
	page: null,
	pageActionsComplete: true,
	pageIndex: -1,
	totalPages: 0,
	isFirstPage: true,
	isLastPage: true,
	pageAnswers: []
};


export type Context = {
	state: IAssessmentState;
	dispatch: React.Dispatch<Actions>;
};
